import React from 'react';
import PropTypes from 'prop-types';
import Button from '@prisjakt/ui-button';
import T from '@prisjakt/ui-translate';

import * as S from './styles';

const ApplyFilterButton = ({ productCount, hasFiltered, onClick }) => (
  <S.ApplyFilterArea>
    <S.ProductCount>
      <T domain="filter" n={productCount}>
        result.n-products
      </T>
    </S.ProductCount>
    <Button
      style={{ width: '100%' }}
      color="primary"
      variant={!hasFiltered ? 'outlined' : 'default'}
      onClick={onClick}
    >
      <T domain="filter">
        {hasFiltered ? 'button.apply-filter' : 'button.apply-filter-disabled'}
      </T>
    </Button>
  </S.ApplyFilterArea>
);

ApplyFilterButton.propTypes = {
  productCount: PropTypes.number,
  hasFiltered: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

ApplyFilterButton.defaultProps = {
  productCount: 0,
  hasFiltered: true,
};

export default ApplyFilterButton;
